import { memo, useCallback } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { Dropdownlist } from '@/components/Dropdownlist';
import type { FormFieldBaseProps } from './field-base';

export interface SelectFieldProps extends FormFieldBaseProps<string | null | undefined> {}

export const SelectField = memo(function SelectField({
  field,
  value,
  onChange,
  readOnly = false,
  error,
}: SelectFieldProps) {
  const { theme } = useTheme();
  const options = field.options ?? [];

  const handleChange = useCallback(
    (next: string | number | null) => {
      onChange(next == null || next === '' ? null : String(next));
    },
    [onChange],
  );

  const errorId = error ? `${field.key}__error` : undefined;
  return (
    <div
      className={'form-group select-field' + (theme ? ' ' + theme : '') + (error ? ' has-error' : '')}
      title={error || undefined}
      aria-invalid={error ? true : undefined}
      aria-describedby={errorId}
    >
      <label className={'field-label' + (field.required ? ' required' : '')} htmlFor={field.key}>
        {field.label}
      </label>
      <Dropdownlist
        value={value ?? null}
        items={options}
        sortItems={false}
        searchable={options.length > 8}
        clearable={!field.required}
        disabled={readOnly}
        placeholder="-- select --"
        onChange={handleChange}
      />
      {error ? <div id={errorId} className="form-field-error" role="alert">{error}</div> : null}
    </div>
  );
});
